<template>
  <div class="store-box">
    <div class="segway-store" @click="dialogVisible = true">
      <svg-icon class="img-store" name="ic_segway_store" />
      <div class="title">{{ $t('support.segway_store') }}</div>
      <div class="store-desc">
        {{ $t('selfRepair.order_official_spare_parts') }}
      </div>
      <div class="view-now-box">
        {{ $t('support.buy_now') }}
      </div>
    </div>
    <div class="right-box" v-if="showImgCard">
      <!-- alt="segway-support"  -->
      <img
        :alt="$t('support.segway_store')"
        :src="segwayStoreImg"
        class="right-img"
        loading="lazy" />
    </div>
    <BaseDialog
      v-model="dialogVisible"
      :title="$t('support.redirect_tips')"
      :cancelTxt="$t('support.visit_not_now')"
      :confirmTxt="$t('support.visit_continue')"
      width="500px"
      @onCancel="dialogVisible = false"
      @onConfirm="handleBuyNow">
      <template #content>
        <div class="confirm-tips">{{ $t('support.redirect_confirm') }}</div>
      </template>
    </BaseDialog>
  </div>
</template>
<script lang="ts" setup>
import { useUrl } from '@support/json';
import { useI18n } from 'vue-i18n';
const { $sensorTrack } = useNuxtApp();
const { t } = useI18n();

const { segwayStore, segwayStoreImg } = useUrl();

defineProps({
  url: { type: String, default: '' },
  // 展示右侧图片区域
  showImgCard: {
    type: Boolean,
    default: true
  }
});
const dialogVisible = ref(false);
function handleBuyNow() {
  dialogVisible.value = false;
  $sensorTrack('self_service_click', {
    click_type: t('support.segway_store')
  });
  useWindowsOpen(segwayStore);
}
</script>
<style lang="scss" scoped>
.store-box {
  // margin: auto;
  margin-bottom: 40px;
  display: flex;
  justify-content: center;
  // min-width: 1200px;
}
.segway-store {
  width: 590px;
  height: 280px;
  text-align: center;
  border-radius: 10px;
  background: #f3f6fa;
  .img-store {
    width: 80px;
    height: 80px;
    margin-top: 16px;
    margin-bottom: 24px;
  }
  .title {
    height: 30px;
    margin-bottom: 8px;
    font-size: 20px;
    font-weight: 500;
    color: #000000;
  }
  .store-desc {
    // width: 253px;
    height: 48px;
    margin: auto;
    margin-bottom: 20px;
    font-size: 16px;
    font-weight: 500;
    color: #000000;
    opacity: 0.5;
    padding: 0 16px;
  }
  .view-now-box {
    font-size: 16px;
    font-weight: 500;
    color: #000000;
    line-height: 24px;
    margin-bottom: 30px;
  }
}
.segway-store:hover {
  cursor: pointer;
  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.1);
  transform: translateY(-10px);
  transition: all 0.15s ease-in-out;
  .view-now-box {
    color: #157be1;
    text-decoration: underline;
  }
}
.right-box {
  width: 590px;
  height: 280px;
  margin-left: 20px;
  background: linear-gradient(91deg, #ebebeb 0%, #f5f5f5 100%);
  border-radius: 10px 10px 10px 10px;
  .right-img {
    width: 100%;
    border-radius: 10px 10px 10px 10px;
  }
}
// .right-box:hover {
//   cursor: pointer;
// }

.confirm-tips {
  text-align: center;
  font-weight: 500;
  font-size: 18px;
  color: #000000;
  line-height: 24px;
  opacity: 0.5;
  margin-bottom: 40px;
}
</style>
